var _style, _path, _g, _g2, _g3, _g4, _g5, _path2, _path3, _g6, _g7, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackSubmitted(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 612 630.5",
    style: {
      enableBackground: "new 0 0 612 630.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E6F0F9;}\r\n\t.st1{fill:#BACDEA;}\r\n\t.st2{fill:#FFDC64;}\r\n\t.st3{fill:#FFC853;}\r\n\t.st4{fill:url(#SVGID_1_);}\r\n\t.st5{fill:url(#SVGID_2_);}\r\n\t.st6{fill:#075284;}\r\n\t.st7{fill:#E6E6E5;}\r\n\t.st8{fill:#CFCFCE;}\r\n\t.st9{fill:#267ABA;}\r\n\t.st10{fill:#1366A7;}\r\n\t.st11{fill:#FFFFFF;}\r\n\t.st12{fill:url(#SVGID_3_);}\r\n\t.st13{fill:url(#SVGID_4_);}\r\n\t.st14{fill:url(#SVGID_5_);}\r\n\t.st15{fill:url(#SVGID_6_);}\r\n\t.st16{fill:url(#SVGID_7_);}\r\n\t.st17{fill:#676794;}\r\n\t.st18{fill:#2EB8B6;}\r\n\t.st19{fill:url(#SVGID_8_);}\r\n\t.st20{fill:url(#SVGID_9_);}\r\n\t.st21{fill:#4E3D16;}\r\n\t.st22{fill:url(#SVGID_10_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M567.6,292.7c7.8,136.4-117.1,261.6-261.6,261.6S18.7,437,44.4,292.7C69.8,150.5,161.5,31.1,306,31.1 S559.9,159.1,567.6,292.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306,484.9c-106,0-192.2-86.2-192.2-192.2c0-106,86.2-192.2,192.2-192.2c106,0,192.2,86.2,192.2,192.2 C498.2,398.7,412,484.9,306,484.9z M306,111.8c-99.8,0-180.9,81.2-180.9,180.9c0,99.8,81.2,180.9,180.9,180.9 c99.8,0,180.9-81.2,180.9-180.9C486.9,193,405.8,111.8,306,111.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M222.3,195.7l-21.7-2l-8.6-20c-0.6-1.4-2.6-1.4-3.2,0l-8.6,20l-21.7,2c-1.5,0.1-2.1,2-1,3l16.3,14.4 l-4.8,21.2c-0.3,1.5,1.3,2.7,2.6,1.9l18.7-11.1l18.7,11.1c1.3,0.8,2.9-0.4,2.6-1.9l-4.8-21.2l16.3-14.4 C224.5,197.7,223.8,195.8,222.3,195.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M192.1,173.7c-0.6-1.4-2.6-1.4-3.2,0l-8.6,20l-21.7,2c-1.5,0.1-2.1,2-1,3l16.3,14.4l-4.8,21.2 c-0.3,1.5,1.3,2.7,2.6,1.9l4.2-2.5c0.6-23.8,11.6-40.5,20.4-50.1L192.1,173.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M288.2,150.2l-21.7-2l-8.6-20c-0.6-1.4-2.6-1.4-3.2,0l-8.6,20l-21.7,2c-1.5,0.1-2.1,2-1,3l16.3,14.4 l-4.8,21.2c-0.3,1.5,1.3,2.7,2.6,1.9l18.7-11.1l18.7,11.1c1.3,0.8,2.9-0.4,2.6-1.9l-4.8-21.2l16.3-14.4 C290.3,152.2,289.7,150.4,288.2,150.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M257.9,128.2c-0.6-1.4-2.6-1.4-3.2,0l-8.6,20l-21.7,2c-1.5,0.1-2.1,2-1,3l16.3,14.4l-4.8,21.2 c-0.3,1.5,1.3,2.7,2.6,1.9l4.2-2.5c0.6-23.8,11.6-40.5,20.4-50.1L257.9,128.2z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M364.5,147.1l-21.7-2l-8.6-20c-0.6-1.4-2.6-1.4-3.2,0l-8.6,20l-21.7,2c-1.5,0.1-2.1,2-1,3l16.3,14.4 l-4.8,21.2c-0.3,1.5,1.3,2.7,2.6,1.9l18.7-11.1l18.7,11.1c1.3,0.8,2.9-0.4,2.6-1.9l-4.8-21.2l16.3-14.4 C366.6,149.2,366,147.3,364.5,147.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M334.2,125.2c-0.6-1.4-2.6-1.4-3.2,0l-8.6,20l-21.7,2c-1.5,0.1-2.1,2-1,3l16.3,14.4l-4.8,21.2 c-0.3,1.5,1.3,2.7,2.6,1.9l4.2-2.5c0.6-23.8,11.6-40.5,20.4-50.1L334.2,125.2z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M435.8,179l-21.7-2l-8.6-20c-0.6-1.4-2.6-1.4-3.2,0l-8.6,20l-21.7,2c-1.5,0.1-2.1,2-1,3l16.3,14.4l-4.8,21.2 c-0.3,1.5,1.3,2.7,2.6,1.9l18.7-11.1l18.7,11.1c1.3,0.8,2.9-0.4,2.6-1.9l-4.8-21.2l16.3-14.4C437.9,181.1,437.3,179.2,435.8,179z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M405.5,157c-0.6-1.4-2.6-1.4-3.2,0l-8.6,20l-21.7,2c-1.5,0.1-2.1,2-1,3l16.3,14.4l-4.8,21.2 c-0.3,1.5,1.3,2.7,2.6,1.9l4.2-2.5c0.6-23.8,11.6-40.5,20.4-50.1L405.5,157z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -726.3881,
    y1: 352.0009,
    x2: -790.797,
    y2: 432.1318,
    gradientTransform: "matrix(0.9983 -5.766745e-02 5.766745e-02 0.9983 980.3086 -40.9774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7B777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M254.4,398.6l-3.3-3.9c-9.6,7.4-17.8,9.5-24.7,8.7c1,6,2.6,11.9,4.9,17.8 C246.2,414.9,254.4,398.6,254.4,398.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -714.1768,
    y1: 361.8167,
    x2: -778.5853,
    y2: 441.9471,
    gradientTransform: "matrix(0.9983 -5.766745e-02 5.766745e-02 0.9983 980.3086 -40.9774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7B777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M252.3,398.8l17.4-0.3l15.4-9.8c-2.4-1.3-15.1,2.4-15.1,2.4s-13.6-1.3-17.3-1.1c-3,0.2-2.4,4.5-2,6 c0.1,0.3,0.1,0.5,0.1,0.5L252.3,398.8z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 509.5,
    cy: 298.9,
    rx: 42.3,
    ry: 39
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M202.8,272.7l26.6-2.1l0,0l9.2,119.6l0,0l-26.6,2.1c-7.3,0.6-13.7-4.9-14.3-12.3l-7.2-93 C189.9,279.7,195.4,273.3,202.8,272.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M237,370.3c-11,0.9-20.6-7.4-21.5-18.4l-6.2-79.7l-6.6,0.5c-7.3,0.6-12.8,7-12.3,14.3l7.2,93 c0.6,7.3,7,12.8,14.3,12.3l26.6-2.1L237,370.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M197.7,380l-12.3-5c-9.4-3.8-15.7-12.6-16.5-22.6l-2.6-33.6c-0.8-10.1,4.2-19.7,12.8-24.9l11.4-6.9 L197.7,380z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M167,328.9l1.8,23.4c0.8,10.1,7.2,18.8,16.5,22.6l12.3,5l-1.8-23.4l-12.3-5 C174.2,347.8,167.8,339,167,328.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M229.3,270.7l93-7.2l9.2,119.6l-93,7.2L229.3,270.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M237,370.3l93-7.2l1.5,19.9l-93,7.2L237,370.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M337.8,262.3l-15.5,1.2l9.2,119.6l15.5-1.2c24.8-1.9,49.6,2,72.6,11.3l75.4,30.7L477.7,198l-69.8,41.9 C386.6,252.7,362.6,260.4,337.8,262.3L337.8,262.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M498.7,437c-7.2,0.5-13.5-4.9-14-12.1c-0.1-0.8,0-1.6,0.1-2.5c8-74.2,2.2-149.2-17.1-221.3 c-1.9-7,2.2-14.2,9.2-16.1c0.8-0.2,1.6-0.4,2.4-0.4c6.2-0.5,12,3.5,13.6,9.5c20.8,75.3,26.9,153.8,17.9,231.4 C510,431.7,505,436.5,498.7,437z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M456.4,210.8c12.8,51,19,103.5,18.2,156c-0.1,7.4-6.1,13.3-13.5,13.3c-1.7,0-3.3-0.3-4.9-1l-18.2-7.4 c-23-9.4-47.9-13.2-72.6-11.3l-2.2,0.2c-7.3,0.6-13.7-4.9-14.3-12.3l-6.7-86.5c-1.5,0.2-2.9,0.4-4.4,0.5l-15.5,1.2l9.2,119.6 l15.5-1.2c24.8-1.9,49.6,2,72.6,11.3l52.5,21.3l22.9,9.4L477.7,198L456.4,210.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M510.5,416c-7.2,0.5-13.5-4.9-14-12.1c-0.1-0.8,0-1.6,0.1-2.5c7.8-72.7,2.3-146.2-16-216.9 c-0.4,0-0.8,0-1.2,0c-7.2,0.6-12.6,6.9-12,14.1c0.1,0.8,0.2,1.6,0.4,2.4c19.3,72.1,25.1,147.1,17.1,221.3 c-0.8,7.2,4.3,13.7,11.5,14.5c7.2,0.8,13.7-4.3,14.5-11.5l0,0c0.4-3.2,0.6-6.4,0.9-9.6C511.2,415.9,510.9,416,510.5,416 L510.5,416z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M320.4,410.6l-44.9,3.5c-5,0.4-9.9-2.1-12.5-6.4l-11.1-18.5l79.7-6.2l1,13.3 C333.2,403.7,327.7,410.1,320.4,410.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M259.5,402l73.1-5.6l-1-13.3l-79.7,6.2L259.5,402z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M334.2,503.1l-27.5,2.1c-7,0.5-13.2-4.4-14.2-11.3l-12-80.2l39.9-3.1l10.5,58.7c0.8,4.5,3.9,8.3,8.1,10 l7,2.9l0.5,6.6C347,496.2,341.5,502.6,334.2,503.1L334.2,503.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M330.8,483.3c-13.9,1.1-26.3-8.8-28.4-22.6l-3.1-20.8c-1.1-7.3,3.9-14.1,11.2-15.1c0.3,0,0.6-0.1,0.9-0.1 l9.9-0.8l1.1-1.4l-2.1-11.9l-39.9,3.1l12,80.2c1,6.9,7.2,11.9,14.2,11.3l27.5-2.1c7.3-0.6,12.8-7,12.3-14.3l-0.5-6.6L330.8,483.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M310.6,284.4l-13.3,1c-3.7,0.3-6.9-2.5-7.2-6.1c-0.3-3.7,2.5-6.9,6.1-7.2l13.3-1c3.7-0.3,6.9,2.5,7.2,6.1 C317,280.9,314.3,284.1,310.6,284.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M514.8,271.3c2.9-0.7,5.4-0.4,7.9,0.1c4.1,0.9,8.3,2,11.8,4.4c1.5,1,2.9,2.2,4,3.6c0.9,1.1,1.8,2.4,1.8,3.8 c0.1,1.4-0.8,2.8-2.1,3.3c-0.8,0.3-1.5-0.2-2.1-0.7c-0.9-0.8-1.8-1.5-2.8-2.2c-4.2-3-9.1-5.2-14.4-5.5c-1.3-0.1-3.5-0.3-4.2-0.4 c-1.7-0.1-2.9-1.9-2.5-3.8C512.6,272.8,513.6,271.6,514.8,271.3z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M309.2,348.3l-34.6-3.2l-13.8-32c-1-2.2-4.1-2.2-5.1,0l-13.8,32l-34.6,3.2c-2.4,0.2-3.4,3.2-1.6,4.9l26.1,23 l-7.7,33.9c-0.5,2.4,2,4.2,4.1,3l29.9-17.8l29.9,17.8c2.1,1.2,4.7-0.6,4.1-3l-7.7-33.9l26.1-23 C312.6,351.6,311.7,348.6,309.2,348.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M260.8,313.2c-1-2.2-4.1-2.2-5.1,0l-13.8,32l-34.6,3.2c-2.4,0.2-3.4,3.2-1.6,4.9l26.1,23l-7.7,33.9 c-0.5,2.4,2,4.2,4.1,3l6.7-4c0.9-38,18.6-64.8,32.6-80.2L260.8,313.2z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -890.3133,
    y1: 593.1802,
    x2: -870.4272,
    y2: 593.1802,
    gradientTransform: "matrix(0.9983 -5.766745e-02 5.766745e-02 0.9983 980.3086 -40.9774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#293882"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#171042"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M128,595.4c0,0-2,3.6-2,13.4c0,0.9,0.8,1.6,1.7,1.6l17.3-1c0.7,0,1.2-0.7,0.9-1.4 c-1.2-2.9-4.7-10.1-11.7-13.8L128,595.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -888.2961,
    y1: 583.9393,
    x2: -880.231,
    y2: 583.9393,
    gradientTransform: "matrix(0.9983 -5.766745e-02 5.766745e-02 0.9983 980.3086 -40.9774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7B777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M126.9,588.8l1.4,8.1c0.1,0.7,0.7,1.2,1.4,1.3c0.9,0.1,2.3,0.1,3.6-0.2c1.2-0.3,2-1.4,1.9-2.6l-0.5-7.9 L126.9,588.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -848.0232,
    y1: 592.8622,
    x2: -816.821,
    y2: 592.8622,
    gradientTransform: "matrix(0.9983 -5.766745e-02 5.766745e-02 0.9983 980.3086 -40.9774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#293882"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#171042"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M170.7,592c0,0-3,5.3-2.5,12.4c0.1,1.7,1.6,2.9,3.2,2.8l26.8-1.5c1.3-0.1,1.7-1.7,0.6-2.4 c-5.3-3.3-15.6-9.3-23-11.5L170.7,592z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -847.5491,
    y1: 580.358,
    x2: -839.5284,
    y2: 580.358,
    gradientTransform: "matrix(0.9983 -5.766745e-02 5.766745e-02 0.9983 980.3086 -40.9774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7B777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M167.4,583.4l2.7,10c0.3,1.1,1.4,1.8,2.6,1.5c0.7-0.2,1.5-0.5,2.3-1.1c0.8-0.6,1.2-1.6,0.9-2.5l-2.9-12.1 L167.4,583.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -893.3073,
    y1: 509.2122,
    x2: -838.6274,
    y2: 509.2122,
    gradientTransform: "matrix(0.9983 -5.766745e-02 5.766745e-02 0.9983 980.3086 -40.9774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#293882"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#171042"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M122.4,445c0,0-6.9,6.8-7.8,14.6c-0.9,7.8,11.5,132.2,11.5,132.2s7.3,0.8,10.9-1.7c0,0-0.3-81.2,2-100.1 c0,0,22.5,82.9,28.2,97.7c0,0,7,0.4,9.2-1c0,0-10.9-108.5-17.8-127.5L122.4,445z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M138.7,487.4c-0.4,0-0.8-0.2-0.9-0.6l-3.6-11.3l-6.6-3.7c-0.4-0.2-0.6-0.8-0.3-1.2c0.2-0.4,0.8-0.6,1.2-0.3 l6.9,3.9c0.2,0.1,0.3,0.3,0.4,0.5l3.8,11.6c0.2,0.5-0.1,1-0.6,1.1C138.9,487.4,138.8,487.4,138.7,487.4z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M200.5,381.6c-11.4-10.9-32.1-15-44.1-16.4c-5.2-0.6-10.2,2.5-11.7,7.6c-4.5,14.6-16.8,52.7-19.3,59.2 c-2,5.4-4.1,10.6-5.4,13.9c-0.8,2,0.1,4.2,2.1,5c10.2,4.2,28.4,8.6,35.8,10.3c1.6,0.4,3.1-0.9,3-2.6c-0.1-1.4,0.2-2.8,0.9-4.1 l24.8-47.4c18.2,18,33.3,18.9,44.6,14.1c-2.3-5.9-3.9-11.8-4.9-17.8C209.3,401.5,200.5,381.6,200.5,381.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: -798.8484,
    y1: 303.5743,
    x2: -861.2285,
    y2: 418.1916,
    gradientTransform: "matrix(0.9983 -5.766745e-02 5.766745e-02 0.9983 980.3086 -40.9774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7B777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M171.5,343l-7.8,22.8c0,0,10.9,6.7,19.3,5.5l3.4-20.3L171.5,343z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -1151.5441,
    y1: 2753.2393,
    x2: -1179.1125,
    y2: 2789.7102,
    gradientTransform: "matrix(0.7824 -0.6229 0.6229 0.7824 -632.0319 -2540.9592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7B777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M186,326.9c0.2,0.3,8,23,8,23l-13.1,4.1l-10.5-20.5C170.4,333.6,182.2,322.1,186,326.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M175.5,336.5l4.7,11.2c0.1,0.1,0.1,0.3,0.2,0.4c0.6,0.7,2.8,3.2,5.2,0.7c2.1-2.2,4.1-4.2,6-4.6 c0.9-0.2,1.7,0.3,2,1.1c0.7,2.1,2.2,6.8,2.9,11c0.1,0.9-0.4,1.7-1.3,1.9c-2.6,0.6-8,1.8-12.6,1.8c-0.6,0-1.2-0.3-1.5-0.9 c-1.4-2.7-5.8-10.9-7.4-12.9c-1.5-2-4.8-1.7-6.2-1.5c-0.5,0.1-0.9-0.1-1.3-0.3c-1.3-1-3.8-3.6-0.7-7c0.6-0.7,0.6-1.8-0.2-2.4 c-1.5-1.2-3.1-3.5-0.9-6.5c2.2-3.1,5.4-2.8,7.3-2.2c0.8,0.2,1.6-0.1,2-0.9c0.2-0.4,0.6-0.7,1.3-0.7c1,0,1.8-0.8,1.7-1.8 c-0.1-1.9,0.4-4.3,3.6-5.5c5.7-2.1,9.6,3.3,10.2,7.4c0.6,4.2-5.7,6.1-9.5,6.1c-2.9,0-4.8,2.9-5.6,4.3 C175.4,335.5,175.3,336,175.5,336.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: -1191.9209,
    y1: 2782.1211,
    x2: -1169.8088,
    y2: 2759.4348,
    gradientTransform: "matrix(0.7824 -0.6229 0.6229 0.7824 -632.0319 -2540.9592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7B777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M175.5,350.2c0,0-1.4-7.2-4.4-7.4c-3-0.2-5.8,2.5-2.6,6.4C172.6,354.1,175.5,350.2,175.5,350.2z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M300.6,486.4L300.6,486.4c-1.4,0.2-2.8-0.7-3-2.2l-9-55.9c-0.2-1.4,0.7-2.8,2.2-3l0,0c1.4-0.2,2.8,0.7,3,2.2 l9,55.9C303,484.8,302.1,486.2,300.6,486.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackSubmitted);
export default __webpack_public_path__ + "static/media/Feedback_Submitted.dcd957a7.svg";
export { ForwardRef as ReactComponent };